import { GlobalAxios } from "../axios/axios-config";
import {
  IEditTicketMarComTicketAutomationRules,
  INewTicketMarComTicketAutomationRules,
  ITicketMarComTicketAutomationRules,
} from "../models/mar-com-ticket-automation-rules";

const AUTOMATION_RULE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComTicketAutomationRules/";

export const createMarComTicketAutomationRules = (
  item: INewTicketMarComTicketAutomationRules
) => {
  return GlobalAxios.post(AUTOMATION_RULE_ROUTE, item);
};

export const getMarComTicketAutomationRulesById = (id: string) => {
  return GlobalAxios.get<ITicketMarComTicketAutomationRules>(
    AUTOMATION_RULE_ROUTE + id
  );
};

export const updateMarComTicketAutomationRulesById = ({
  item,
  id,
}: {
  item: IEditTicketMarComTicketAutomationRules;
  id: string;
}) => {
  return GlobalAxios.put(AUTOMATION_RULE_ROUTE + id, item);
};
